import { render, staticRenderFns } from "./AS_ShutdownNotices.vue?vue&type=template&id=9898d304&scoped=true&"
import script from "./AS_ShutdownNotices.vue?vue&type=script&lang=js&"
export * from "./AS_ShutdownNotices.vue?vue&type=script&lang=js&"
import style0 from "./AS_ShutdownNotices.vue?vue&type=style&index=0&id=9898d304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9898d304",
  null
  
)

export default component.exports